import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import router from '@/router';
import { getToken } from '@/utils/auth';

// 并发请求全部 token 过期时，避免重复弹 message 和重复跳转
var isTokenExpiredHandling = false;
function handleTokenExpired() {
  if (isTokenExpiredHandling) return;
  isTokenExpiredHandling = true;
  Message.closeAll();
  Message({
    message: 'Login expired, please log in again',
    type: 'error',
    duration: 3 * 1000
  });
  store.dispatch('user/resetToken').then(function () {
    var currentPath = router.currentRoute && router.currentRoute.fullPath;
    var redirect = currentPath && currentPath !== '/login' ? currentPath : '/';
    router.replace("/login?redirect=".concat(encodeURIComponent(redirect))).finally(function () {
      isTokenExpiredHandling = false;
    });
  }).catch(function () {
    isTokenExpiredHandling = false;
  });
}

// const pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// const CancelToken = axios.CancelToken
// const removePending = (config) => {
//   for (const p in pending) {
//     if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
//       pending[p].f() // 执行取消操作
//       pending.splice(p, 1) // 把这条记录从数组中移除
//     }
//   }
// }
// create an axios instance
// const protocol = window.location.protocol // 'http:' : 'https:'
var protocol = 'https:'; // 'https:'
var service = axios.create({
  baseURL: protocol + process.env.VUE_APP_BASE_API.split(':')[1],
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // do something before request is sent

  if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['Token'] = getToken();
  }
  // *******************
  // if (config.cancelToken && config.cancelToken.reason) {
  //   // 如果请求已被取消，直接抛出取消错误
  //   return Promise.reject(config.cancelToken.reason)
  // }
  // *******************

  // removePending(config) // 在一个ajax发送前执行一下取消操作
  // config.cancelToken = new CancelToken((c) => {
  //   // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
  //   pending.push({ u: config.url + '&' + config.method, f: c })
  // })
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  // removePending(response.config) // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
  // 获取自定义响应头数据
  // if (axios.isCancel) {
  //   // 请求被取消，不进行后续处理
  //   console.log('Request canceled:')
  //   return Promise.reject('Request canceled')
  // }
  var customHeader = response.headers['Response_code'];
  var res = response.data;
  if (res.size > 0) {
    return response;
  }
  // if the custom code is not 20000, it is judged as an error.
  if (res.code !== 200 && res.code !== 0 && res.code !== 1 && res.code !== 130001 && res.code !== 130002 && res.code !== 130003 && res.code !== -1 && res.code !== 2 && +customHeader !== 200) {
    // 100002 / 40001 token Invalid（过期或非法）→ 直接跳登录
    if (res.code === 100002 || res.code === 40001) {
      handleTokenExpired();
      return Promise.reject(new Error(res.message || 'token Invalid'));
    }
    var msg = '';
    if (res.message && res.message.length > 200) {
      msg = res.message.slice(0, 200) + '...';
    } else {
      msg = res.message;
    }
    Message({
      message: msg || 'Error',
      type: 'error',
      duration: 5 * 1000
    });

    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // to re-login
      MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        confirmButtonText: 'Re-Login',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        store.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    }
    // 处理接口没有返回code被拦截
    // return Promise.reject(new Error(res.message || 'Error'))
  } else {
    return res;
  }
}, function (error) {
  console.log('err' + error); // for debug
  if (!('err' + error === 'errCancel')) {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
  }
  // *******************
  // if (axios.isCancel(error)) {
  //   // 请求被取消，不进行后续处理
  //   console.log('Request canceled:', error.message)
  //   return Promise.reject(error)
  // }
  // *******************
  return Promise.reject(error);
});
export default service;